/** Utilities to help with Next.js data fetching */
import urlJoin from 'url-join'

/**
 * Takes an array of pathname segments
 *
 * E.g. given a Next.js page with filename `/something/[...path].tsx`,
 * getStaticProps or getServerSideProps will have `req.params.path` available
 * on context If you access the page at `/something/foo/bar/baz`,
 * `req.params.path` will be `["foo", "bar", "baz"]. This function reconstructs
 * that back into a full path segment, i.e. `/foo/bar/baz`.
 */
export function pathParamToPath(pathParam: string | string[]): string {
  if (typeof pathParam === 'string') return urlJoin(pathParam)
  return urlJoin(`/`, ...pathParam)
}
